export default __webpack_public_path__ + "static/media/dtsu5168_direct_gw152.c47791e1.png";